import { marked } from 'marked';
import DOMPurify from 'dompurify';

import './MarkdownContent.scss';

const MarkdownContent = ({html = ''})  => {
  const cleanHtml = DOMPurify.sanitize(marked.parse(html));
  return <div className='MarkdownContent' dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
};

export default MarkdownContent;